import { SafeResourceUrl } from '@angular/platform-browser';

export interface ConsultPatientState {
  turnType: 'GENERAL' | 'ODONTOLOGY';
  saveDraft: boolean;
  historyPdf?: SafeResourceUrl;
}

export const consultPatientIS: ConsultPatientState = {
  turnType: 'GENERAL',
  saveDraft: false
};
